var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-banner',{staticClass:"text-white bg-red-4",attrs:{"rounded":""},scopedSlots:_vm._u([{key:"avatar",fn:function(){return [_c('q-icon',{attrs:{"name":"warning","size":"md","color":"white"}})]},proxy:true}])},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }